const locale = {
  "inspections.accessibility":
    "Accesibilidad a las personas expuesta a material con amianto",
  "inspections.amphibolesPresence":
    "Presencia de anfiboles (crocidolita, amosita, tremolita, antofilita y / o actinolita)",
  "inspections.asbestosVariety": "Variedad de amianto",
  "inspections.between1150": "Entre 11 y 50 metros lineales y / o cuadrados",
  "inspections.between13": "De 1 a 3",
  "inspections.between2501000": "Habitaciones entre 250 y 1000 metros cúbicos",
  "inspections.between410": "De 4 a 10",
  "inspections.difficultyAccessible":
    "Difícilmente accesible en el uso cotidiano de la instalación (accesibilidad baja). Altura superior a 2,2 metros. Posibilidad de interacción ocasional del MCA.",
  "inspections.easyAccessible":
    "Fácilmente accesible en el uso cotidiano de la instalación (accesibilidad media). Posibilidad de interacción fácil del MCA.",
  "inspections.equipmentLocation": "Localización del equipo o instalación",
  "inspections.extentQuantity": "Extensión / cantidad del material con amianto",
  "inspections.frequent":
    "El material se encuentra en una zona con ruido y vibraciones (salas de máquinas). Se realizan actividades frecuentes que implican manipular el material (más de una vez al mes).",
  "inspections.friability": "Friabilidad del material",
  "inspections.greatDamage":
    'Gran daño o desprendimiento de las láminas que conforman los materiales proyectados o "flocages" y aislamientos térmicos. Escombros de amianto visibles.',
  "inspections.highAccessible":
    "Accesible para cualquier uso (accesibilidad alta). Altura inferior a 2,2 metros. Posibilidad de interacción frecuente del MCA.",
  "inspections.highFriability":
    'Aislamientos y proyectados o "flocages" sin encapsular. Material de ALTA FRIABILIDAD, se fragmenta muy fácilmente solo con tocarlo, pudiendo desprenderse.',
  "inspections.inaccessible":
    "Inaccesible en el uso cotidiano de la instalación",
  "inspections.largeAndWellVentilated":
    "En grandes espacios y bien ventilados > 100 m3",
  "inspections.lessThan10": "Menos de 10 metros lineales y / o cuadrados",
  "inspections.lessThan250":
    "Espacios menores de 250 metros cúbicos. Espacios que actúan como plenum en un sistema de acondicionamiento de aire independientemente del tamaño, o materiales sometidos a corrientes de aire.",
  "inspections.littleDamage":
    "Poco daño: pequeños arañazos o marcas, bordes rotos en tableros, losetas, etc.",
  "inspections.lowFriability":
    'Proyectados, "flocages" o aislantes sellados; tableros aislantes (con la cara expuesta pintada o encapsulada), amianto cemento, etc. Material de BAJA FRIABILIDAD, se puede dañar con la mano, aunque con dificultad. El material puede resultar dañado por medio de impactos. El material tiene base de cemento y deja gránulos en la mano, pero no polvo. El material ha perdido su integridad en parte.',
  "inspections.materialStatus": "Estado del material (o posible deterioro)",
  "inspections.mediumDamage":
    "Daño medio: rotura significativa de materiales o grandes roturas en pequeñas áreas donde los materiales dañados pueden liberar fibras, daños por agua visibles.",
  "inspections.mediumFriability":
    'Tableros aislantes sin encapsular o aislamientos y proyectados o "flocages" encapsulados. Material de FRIABILIDAD MEDIA, es fácil de fragmentar por la simple presión de la mano. Se pueden retirar trozos simplemente a mano. El material tiene base de cemento y deja un residuo polvoriento en las manos al frotarlo.',
  "inspections.moreThan10": "Más de 10",
  "inspections.moreThan51": "Más de 51 metros cuadrados y / o lineales",
  "inspections.never":
    "Nunca se realizan actividades que impliquen manipular o perturbar el material",
  "inspections.noDamage": "Buen estado: no hay daños visibles",
  "inspections.noFriability":
    "Compuestos reforzados conteniendo amianto, plásticos reforzados, resinas, vinilos, etc. Material NO FRIABLE, duro y que no puede ser dañado con la mano. Se precisa un objeto para dañarlo. El material esta íntegro.",
  "inspections.none": "Ninguno",
  "inspections.occasionally":
    "Se realizan actividades que implican circulación por la zona de localización del material con amianto, o actuaciones que implican manipular el material muy ocasionalmente (menos de 1 al mes)",
  "inspections.occasionallyAccessible":
    "En espacios cerrados, aunque ocasionalmente accesibles",
  "inspections.onlyChrysotile": "Solo crisotilo",
  "inspections.outdoorOrEncapsulated": "Al aire libre o totalmente encapsulado",
  "inspections.potentiallyExposed":
    "Número de personas potencialmente expuestas (incluye personas trabajadoras y usuarias)",
  "inspections.smallQuantities":
    "Pequeñas cantidades, 1 unidad (junta, cuerda, cordón, placa, bajante)",
  "inspections.technicalAccessibility": "Accesibilidad técnica",
  "titularidad-privado": "PRIVADO",
  "titularidad-publico": "PÚBLICO",
  "titularidad-todo": "TODO",
  "uso_del_edificio_Servicios Públicos": "Públicos servicios",
  address: "Dirección",
  amortization_graph: "Gráfica de amortización",
  area: "Uso de suelo",
  ASBESTOS_INVENTORY: "Censo amianto",
  asbestos_susceptibility: "Susceptibilidad de contener amianto",
  asbestos_type: "Tipo de amianto",
  asbestos: "Amianto",
  asbestus_data: "Inf. amianto",
  attachments: "Archivos",
  available_area: "Área Disponible",
  available_trees: "Árboles Disponibles",
  base_layer_selector: "Capa base",
  base_layer: "Capa base",
  biomass: "Biomasa",
  building_age: "Antigüedad del edificio",
  building_creation_date: "Fecha de construcción",
  catastro_description:
    "Información relevante sobre las edificaciones obtenida directamente desde el catastro.",
  catastro_title: "Catastro",
  center_aoi: "Centrar AOI",
  center_user: "Centrar usuario",
  click_to_select_a_project: "Mis proyectos",
  co2: "CO₂",
  coming_soon: "No disponible",
  common_name: "Nombre Común",
  copying_element: "Copiando elemento",
  creating_element: "Creando elemento",
  creating_new_element: "Creando nuevo elemento",
  crown_diameter: "Diámetro de Copa",
  current_use: "Uso actual",
  cyclosm_description:
    "Permite visualizar la altitud y relieve del terreno mediante curvas de nivel, así como elementos naturales (ríos, montañas, bosques) y artificiales (calles, carreteras, edificios).",
  cyclosm_title: "Mapa Topográfico",
  dashboard: "Panel de control",
  delete_attachment_body:
    "¿Estás seguro de que deseas eliminar este archivo adjunto? Esta acción no se puede deshacer.",
  delete_attachment_title: "Eliminar archivo adjunto",
  delete_element_body:
    "¿Estás seguro de que deseas eliminar este elemento? Esta acción no se puede deshacer.",
  delete_element_title: "Eliminar elemento",
  delete_image: "Eliminar imagen",
  delete: "Borrar",
  deleting_element: "Eliminando elemento",
  deleting_image: "Eliminando imagen",
  description: "Descripción",
  discard_changes_body: "Tienes cambios sin guardar. ¿Deseas descartarlos?",
  discard_changes_title: "Descartar cambios",
  discard: "Descartar",
  district_b_code: "Código B del distrito",
  district_bar_code: "Código de barras del distrito",
  district_code: "Código de distrito",
  district_name: "Nombre del distrito",
  district_tx: "Distrito TX",
  edification_data: "Inf. edificación",
  EDIFICATION_INVENTORY: "Edificación",
  edification: "Edificación",
  edit_feature: "Editar feature",
  edit: "Editar",
  element_copied_successfully: "Elemento copiado correctamente",
  element_copying_error: "Error copiando elemento",
  element_created_successfully: "Elemento creado correctamente",
  element_creating_error: "Error creando el elemento",
  element_deleted_successfully: "Elemento eliminado correctamente",
  element_type: "Tipo de elemento",
  energy_graph: "Gráfica de energía",
  exit_edition: "Salir fotointepretación",
  filters: "Filtros",
  form: "Formulario",
  fx_creation: "Fecha de creación",
  fx_modification: "Fecha de modificación",
  google_satellite_description:
    "Procedente de servicios de Google. En ciertas regiones proporciona imágenes más actualizadas y con mayor resolución que las proporcionadas por IGN.",
  google_satellite_title: "Google",
  has_lab_measures: "Tiene medidas de laboratorio",
  header_category: "Categoría",
  header_description: "Descripción",
  header_image: "Imagen",
  header_tag: "Etiquetas",
  header_title: "Título",
  height: "Altura",
  image_deleted_successfully: "Imagen eliminada correctamente",
  image_uploaded_successfully: "Imagen subida correctamente",
  images: "Imágenes",
  ine_code: "Código INE",
  info: "Información",
  inspection_type: "Tipo de inspección",
  is_asbestos: "Contiene amianto",
  lab_measure_note: "Nota de medidas de laboratorio",
  lab_measure_ref_code: "Código de referencia de medidas de laboratorio",
  layer_attributions: "Atribuciones de las capas",
  layer_groups: "Grupo de capas",
  layer_visualization_control: "Control de la visualización de las capas",
  layers: "Capas",
  leaf_type: "Tipo de Hoja",
  legend: "Leyenda",
  less: "Menos",
  link_catastro: "Enlace al catastro",
  link_maps: "Enlace a Google Maps",
  link: "Link",
  loading_data: "Cargando datos",
  loading_legend: "Cargando leyenda",
  loading_map: "Cargando mapa",
  log_out: "Cerrar sesión",
  m2_catastro: "Metros cuadrados catastrales",
  made_by: "Creado por",
  main_species: "Especie principal",
  major_neighborhood: "Barrio principal",
  more: "Más",
  municipality: "Municipio",
  n_elements_inside: "Número de elementos",
  n_ref_catastral: "Número de referencia catastral",
  name: "Nombre",
  neighborhood_code: "Código del barrio",
  neighborhood_mt: "Barrio MT",
  neighborhood_name: "Nombre del barrio",
  neighborhood_number: "Número de barrio",
  no_attributions: "Sin atribuciones",
  no_changes_made: "Sin cambios que guardar",
  no_info_to_display: "Localización sin información",
  no: "No",
  obtaining_data: "Obteniendo datos",
  open_in_new_tab: "Abrir en una nueva pestaña",
  osm_description:
    "Mapa basado en Open Street Map que permite visualizar nombres de calles y edificaciones de interés.",
  osm_title: "Callejero",
  owner: "Propietario",
  pa: "Profundidad",
  percent: "Porcentaje",
  pnoa_description:
    "Este mapa base utiliza el WMTS proporcionado por el PNOA para una visualización clara de fotografías de alta resolución del terreno.",
  pnoa_title: "Aérea",
  prev_state: "Estado Anterior",
  print: "Imprimir",
  prop_state: "Estado Propuesto",
  province: "Provincia",
  questionsPhase1: "Entorno",
  questionsPhase2: "Material",
  questionsPhase3: "Suma de valores de los factores",
  read_only: "solo lectura",
  risk_final_value: "Valor final de riesgo",
  risk_form_value: "Valor del formulario de riesgo",
  risk_simplify_type: "Tipo de simplificación de riesgo",
  risk_type_used: "Tipo de riesgo",
  save_changes_body: "¿Quieres guardar los cambios antes de salir?",
  save_changes_title: "Guardar cambios",
  save: "Guardar",
  season: "Temporada",
  select_project: "Seleccione un proyecto",
  selected_point: "Punto seleccionado",
  selection_details: "Detalles de la selección",
  shape_length: "Longitud de la forma",
  show_layer_attributions: "Mostrar atribuciones de las capas",
  show_more: "Mostrar más",
  simple: "Simple",
  solar_data: "Inf. solar",
  species_count: "Cantidad de especies",
  species: "Especies",
  status: "Estado",
  susceptibility_label_alta: "Alta",
  susceptibility_label_baja: "Baja",
  susceptibility_label_media: "Media",
  susceptibility_label_muy_alta: "Muy alta",
  susceptibility_title:
    "Susceptibilidad mínima de contener amianto representada",
  table: "Tabla",
  title: "Título",
  titularidad: "Titularidad",
  to: "A",
  toggle_visibility: "Alternar visibilidad",
  tooltipTeledeteccion: "Fotointerpretación",
  trees: "Árboles",
  txt_description_title_information:
    "En esta herramienta podrás obtener la cotización para servicios de teledetección de amianto para ayuntamientos, además, de análisis que te ayudarán a entender y proporcionar información relevante para su cliente",
  txt_description_title:
    "Censo de instalaciones con presencia de amianto en ayuntamientos obligatorio según ley 07/2022",
  txt_description:
    "Los ayuntamientos están obligados a realizar un censo de instalaciones y emplazamientos con amianto, incluyendo un calendario que planifique su retirada, según la Ley 07/2022, de 8 de abril de residuos y suelos contaminados para una economía circular. Cumple con la ley 07/2022 de manera sencilla con nuestra solución\nAgforest proporciona la solución completa para su censo de instalaciones de amianto, utilizando  algoritmos de inteligencia artificial e imágenes satélite para la detección de amianto en su localidad.",
  txt_footer_legal: "Aviso legal",
  txt_footer_privacity: "Política de privacidad y cookies",
  type: "Tipo",
  undo: "Deshacer",
  uploading_image: "Subiendo imagen",
  usage: "Uso",
  uso_del_edificio_Agrícola: "Agrícola",
  uso_del_edificio_Industrial: "Industrial",
  uso_del_edificio_Oficinas: "Oficinas",
  uso_del_edificio_Otros: "Otros",
  uso_del_edificio_Residencial: "Residencial",
  uso_del_edificio_Retail: "Retail",
  uso_del_edificio: "Uso del edificio",
  visibility: "Opacidad",
  visualization_selector: "Visualización",
  visualization: "Visualización",
  website: "Sitio web",
  write_an_address: "Escriba una dirección",
  years: "Años",
  yes: "Sí",
  zonas_catastro_description:
    "Este mapa combina dos capas de información: zonas edificadas obtenidas del catastro y fotografías aéreas de la región.",
  zonas_catastro_title: "Aéreas + Catastro",
  zoom_in: "Acercar vista",
  zoom_out: "Alejar vista",
  MCA: "MCA - Contiene amianto",
  MPCA: "MPCA - Posible amianto",
  NOMCA: "NOMCA - Sin amianto",
  PRELIMINAR: "Preliminar",
  BASICO: "Básico",
  DETALLADO: "Detallado",
  CRISOTILO: "Crisotilo",
  ASBESTOS: "Amianto",
  CUBIERTA: "Cubierta",
  PARAMENTO: "Pared",
  material: "Material",

  adhesives_cements_sealants: "Adhesivos, Cementos, Selladores",
  adhesives: "Adhesivos",
  adhesive_cement: "Cemento adhesivo",
  caulking: "Calafateo",
  cement: "Cemento",
  duct_adhesive: "Adhesivo para conductos",
  finishing_cement: "Cemento de acabado",
  furnace_cement: "Cemento de horno",
  insulating_cement: "Cemento aislante",
  joint_cement: "Cemento para juntas",
  masonry_cement: "Cemento Masónico",
  putties: "Masillas",
  mortar: "Mortero",
  plastic_cement: "Cemento Plástico",
  sealant: "Sellador",

  asbestos_paper_board_roll: "Papel de asbesto, Cartón enrollable, Cartón",
  asbestos_paper: "Papel de amianto",
  corrugated_paper: "Papel corrugado",
  flexible_board: "Tablero flexible",
  millboard: "Millboard",
  permanent_board: "Tablero permanente",
  roll: "Rollo",
  vinyl_wallpaper: "Papel pintado de vinilo",

  automotive_materials_friction: "Materiales Automotrices, Fricción",
  brake_linings: "Forros de freno",
  brake_pads: "Pastillas de freno",
  brakes: "Frenos",
  clutch_linings: "Forros de embrague",
  disc_brakes: "Frenos de disco",
  drum_brakes: "Frenos de tambor",
  elevator_brake_shoes: "Zapatas de freno de ascensor",
  transmission_plates: "Placas de transmisión",

  cement_pipes_boards_sheets_plastics:
    "Tuberías de Cemento, Placas de Cemento, Láminas, Plásticos",
  asbestos_board: "Tablero de amianto",
  asbestos_sheets: "Hojas de amianto",
  cement_pipes: "Tuberías de cemento",
  plastics: "Plásticos",
  stone_coating: "Revestimiento de piedra",

  clay_compounds_paints_plasters: "Arcilla, Compuestos, Pinturas, Yesos",
  acoustic_plaster: "Yeso Acústico",
  asphalt: "Asfalto",
  filler: "Relleno",
  finishing: "Finalizar",
  joint_compound: "Compuesto para juntas",
  paint: "Pintar",
  patching: "Parcheo",
  plaster: "Yeso",
  putty: "Masilla",
  putty_compounds: "Compuestos de masilla",

  electrical_mechanical_products: "Productos eléctricos y mecánicos",
  boilers: "Calderas",
  cables_wires: "Cables y alambres",
  electrical_boards: "Tableros Eléctricos",
  furnaces: "Hornos",
  generators: "Generadores",
  heating_ducts: "Conductos de calefacción",
  pumps: "Bombas",
  turbines: "Turbinas",
  valve_rings: "Anillos de válvula",
  valves: "Válvulas",
  weather_resistant_jackets: "Chaquetas resistentes a la intemperie",
  wiring_insulation: "Aislamiento de cableado",

  flooring_tiles: "Suelos, Azulejos",
  ceiling_tiles: "Tejas del techo",
  tiles: "Baldosas",
  flooring: "Suelos",
  slabs: "Losas",
  vinyl_linoleum_floors: "Pisos de vinilo y linóleo",
  wall_tiles: "Azulejos de pared",

  gaskets_packings_sealing_materials: "Juntas, Empaques, Materiales de Empaque",
  braided_packing: "Embalaje trenzado",
  gasket_material: "Material de junta",
  gaskets: "Juntas",
  packing_material: "Material de empaque",
  rope_packing: "Embalaje de cuerda",
  sheet_packing: "Embalaje de hojas",

  household_products: "Productos de uso doméstico",
  agricultural_filler: "Relleno agrícola",
  attic_insulation: "Aislamiento del ático",
  cigarette_filters: "Filtros de cigarrillos",
  clay_pots: "Ollas de barro",
  fertilizer: "Fertilizante",
  exhaust_hoods: "Campanas de extracción",
  iron_stands: "Soportes de hierro",
  ironing_board_covers: "Fundas para tablas de planchar",
  lab_hoods: "Campanas de laboratorio",
  potting_mixes: "Mezclas para macetas",
  stove_mats: "Alfombrillas para estufa",

  panels_drywall_wall_coverings:
    "Paneles, Paneles de Yeso, Revestimientos de Paredes",
  acoustic_panels: "Paneles acústicos",
  drywall: "Paneles de yeso",
  marine_panel: "Panel marino",
  panels: "Paneles",
  gypsum_board: "Placa de yeso",
  wallboard: "Panel de yeso",

  pipe_covering_block: "Cubierta y bloque de tuberías",
  block_insulation: "Aislamiento de bloques",
  calcium_silicate: "Silicato de calcio",
  duct_insulation: "Aislamiento de conductos",
  insulation: "Aislamiento",
  magnesia: "Magnesia",
  pipe_insulation: "Aislamiento de tuberías",
  preformed_pipe_wrap: "Envoltura de tubería preformada",
  sponge_block: "Bloque de esponja",
  sleeveless_jacket: "Chaqueta sin mangas",

  protective_clothing: "Ropa protectora",
  aprons: "Delantales",
  asbestos_helmet: "Casco de amianto",
  dust_masks: "Máscaras antipolvo",
  glassblowers_mittens: "Manoplas para sopladores de vidrio",
  gloves: "Guantes",
  lab_gloves: "Guantes de laboratorio",
  mittens: "Mitones y manoplas",
  respirators: "Respiradores",
  sleeves: "Mangas",
  textile_garments: "Prendas Textiles",

  protective_fireproof_coatings: "Recubrimientos protectores, ignífugos",
  asbestos_curtains: "Cortinas de amianto",
  asbestos_spray: "Aerosol de amianto",
  boiler_coating: "Revestimiento de calderas",
  fireproof_blankets: "Mantas ignífugas",
  fire_dampers: "Compuertas cortafuegos",
  fire_doors: "Puertas de fuego",
  fireproof_cement: "Cemento ignífugo",
  fireproof_materials: "Materiales ignífugos",
  insulating_coating: "Revestimiento aislante",
  roof_coating: "Revestimiento de techo",
  textured_coatings: "Recubrimientos texturizados",
  coating: "Recubrimiento",

  raw_asbestos: "Amianto crudo",
  asbestos_fiber: "Fibra de amianto",
  fake_snow: "Nieve falsa",
  raw_asbestos: "Amianto en bruto",
  calsilite_silicate: "Silicato de calsilita",
  talc_powder: "Polvo de talco",
  transite: "Tránsito",
  vermiculite: "Vermiculita",

  refractory_products: "Productos refractarios",
  castables: "Castables",
  refractory_brick: "Ladrillo refractario",
  marinite: "Marinita",
  refractory_cement: "Cemento refractario",
  refractory_products: "Productos refractarios",

  rope_wick_cord_tape_cork: "Cuerda, Mecha, Cordón, Cinta, Corcho",
  asbestos_cord: "Cordón de amianto",
  asbestos_rope: "Cuerda de amianto",
  cork_coating: "Revestimiento de corcho",
  foil_rope: "Cuerda de lámina",
  tape: "Cinta",
  wicking: "Wicking",

  textiles_felts_fabrics: "Textiles, Fieltros, Telas",
  asbestos_blanket: "Manta de amianto",
  asbestos_canvas: "Lona de amianto",
  asbestos_fabric: "Tela de amianto",
  asbestos_felt: "Fieltro de amianto",
  asbestos_lap: "Vuelta de amianto",
  asbestos_wool: "Lana de amianto",
  asbestos_thread: "Hilo de amianto",
  lagging: "Rezagado",
  roving: "Itinerante",
  textiles: "Textiles",
  element_updated_successfully: "Elemento actualizado correctamente",
  updating_element: "Actualizando elemento",
  link_to_google_maps: "Enlace a Google Maps",
  link_to_google_earth: "Enlace a Google Earth",
  PENDING: "Pendiente",
  IN_REVIEW: "En revisión",
  REVIEWED: "Revisado",
  CLEAR: "Listo",
  change_grid_status: "Cambiar estado de la rejilla a...",
  changing_grid_status: "Cambiando estado de la rejilla",
  grid_status_changed_successfully:
    "Estado de la rejilla cambiado correctamente",
  BAJANTE: "Bajante",
  LAB_MEASURES: "Muestras de laboratorio",
  no_images: "No hay imágenes",
  expand_image: "Expandir imagen",
  "Muy Alto": "Muy Alto",
  Alto: "Alto",
  Medio: "Medio",
  Bajo: "Bajo",
  Industrial: "Industrial",
  Residencial: "Residencial",
  Oficinas: "Oficinas",
  Agrícola: "Agrícola",
  Retail: "Retail",
  "Servicios Públicos": "Servicios Públicos",
  Otros: "Otros",
  Privado: "Privado",
  Público: "Público",
  Municipal: "Municipal",
  fx_pending: "Fecha de pendiente",
  fx_clear: "Fecha de listo",
  fx_review: "Fecha de revisión",
  link_to: "Enlace a...",
  ASBESTOS_SUSCEPTIBILIDAD: "Susceptibilidad amianto",
  building_refurbishing_date: "Fecha de renovación del edificio",
  cannot_display_image: "No se puede mostrar la imagen",
  close_image: "Cerrar imagen",
  no_grid_to_update: "Sin rejilla que actualizar",
  download_image: "Descargar imagen",
  save_geometry: "Guardar geometría",
  save_geometry_title: "Guardar geometría",
  save_geometry_body: "¿Estás seguro de que deseas guardar la geometría?",
  tags: "Etiquetas",
  aois: "AOIs",
  show_info: "Mostrar información",
  features: "Elementos",
  create_inventory_element: "Crear elemento en censo de amianto...",
  point: "Punto",
  polygon: "Polígono",
  invalid_geometry: "Geometría no válida",
  add_new_feature: "Añadir nuevo elemento",
  IN_PROGRESS: "En progreso",
  tooltipChangeGrid: "Regenerar rejilla",
  from_layer: "Desde capa",
  small: "Pequeño",
  medium: "Mediano",
  large: "Grande",
  select_layer: "Selecciona una capa",
  size: "Tamaño",
  name_en: "Nombre inglés",
  name_es: "Nombre español",
  regenerating_grid: "Regenerando rejilla",
  grid_regenerated_successfully: "Rejilla regenerada correctamente",
  reset_rotation: "Resetear rotación",
  "Sin datos": "Actual",
  "Cobertura arbórea": "Cobertura arbórea",
  Matorral: "Matorral",
  Pastizales: "Pastizales",
  "Tierras de cultivo": "Tierras de cultivo",
  "Área urbanizada": "Área urbanizada",
  "Vegetación escasa o desnuda": "Vegetación escasa o desnuda",
  "Cuerpos de agua permanentes": "Cuerpos de agua permanentes",
  "Humedales herbáceos": "Humedales herbáceos",
  Manglares: "Manglares",
  "Musgos y líquenes": "Musgos y líquenes",
  category: "Categoría",
  area_properties: "Propiedades del área",
  actual_ground_use_distribution: "Distribución del uso del suelo actual",
  market_value: "Valor de mercado",
  // area_km2: "Área (km²)",
  // market_value_euros: "Valor de mercado (€)",
  // market_value_euros_per_km2: "Valor de mercado (€ / km²)",
  // carbon_Mg: "Carbono (Mg)",
  // carbon_Mg_per_km2: "Carbono (Mg / km²)",
  // biomass_Mg: "Biomasa (Mg)",
  // biomass_Mg_per_km2: "Biomasa (Mg / km²)",
  // biomass_tonnes: "Biomasa (toneladas)",
  // biomass_tonnes_per_km2: "Biomasa (toneladas / km²)",
  // carbon_kg: "Carbono (kg)",
  // carbon_kg_per_km2: "Carbono (kg / km²)",
  // biomass_kg: "Biomasa (kg)",
  // biomass_kg_per_km2: "Biomasa (kg / km²)",
  // carbon_credits_tCO2e: "Créditos de carbono (tCO2e)",
  // carbon_credits_tCO2e_per_km2: "Créditos de carbono (tCO2e / km²)",
  // area_ha: "Área (ha)",
  // area_m2: "Área (m²)",

  area_km2: "Área",
  market_value_euros: "Valor total",
  market_value_euros_per_km2: "Valor de mercado",
  carbon_Mg: "Carbono",
  carbon_Mg_per_km2: "Carbono",
  biomass_Mg: "Biomasa",
  biomass_Mg_per_km2: "Biomasa",
  biomass_tonnes: "Biomasa",
  biomass_tonnes_per_km2: "Biomasa",
  carbon_kg: "Carbono",
  carbon_kg_per_km2: "Carbono",
  biomass_kg: "Biomasa",
  biomass_kg_per_km2: "Biomasa",
  carbon_credits_tCO2e: "Créditos de carbono",
  carbon_credits_tCO2e_per_km2: "Créditos de carbono",
  area_ha: "Área",
  area_m2: "Área",
  carbon_credits: "Créditos de carbono",
  copy: "Copiar",
  copied: "¡Copiado!",
  geometry_error: "Geometría inválida",
  market_value_euros_per_m2: "Valor por superficie",
  expand: "Expandir",
  contract: "Contraer",
  unavailable: "No disponible",
  data_filter_control: "Control de filtrado de datos",

  // TUTORIAL
  next: "Siguiente",
  back: "Atrás",
  last: "Terminar",
  skip: "Saltar",
  of: "de",
  tutorial_step_title_1: "Bienvenido al visor de Agforest",
  tutorial_step_body_1:
    "En el siguiente tutorial te mostraremos las funcionalidades de la web.",
  tutorial_step_body_2: "Controles sobre el visor del mapa",
  tutorial_step_body_3: "Opciones del menú lateral",
  tutorial_sidebar_button: "Aquí están Tus proyectos y las opciones de capas.",
  tutorial_user_directions_button:
    "Buscador de direcciones y opciones del usuario.",
  tutorial_map_controls_button: "Controles básicos del mapa.",
  tutorial_attributions_button: "Atribuciones de las capas.",
  tutorial_step_title_4: "Tutorial terminado",
  tutorial_step_body_4: "¡Disfruta de tu experiencia en Agforest! 😃😃",
  tutorial_my_projects_button:
    'Si haces click en "Mis proyectos", verás todos tus proyectos contratados.',
  tutorial_layers:
    "Los grupos de capas, que a su vez contienen capas individuales, contienen acciones que puedes realizar sobre cada capa.",
  tutorial_tabs:
    "Cambia de pestaña para acceder a los filtros o paneles de control, si existieran.",
  finish: "Finalizar",
  previous: "Anterior",
  select_language: "Seleccionar idioma",
  tutorial_carbon_body_1:
    "Primero selecciona el área del mapa que quieras analizar.",
  tutorial_carbon_title: "Estudio de carbono",
  tutorial_carbon_body_2:
    "En esta ventana verás el resumen del estudio de carbono, en el que podrás hacer pruebas.",
  tutorial_carbon_category:
    "Cambia de categoría para ver las nuevas propiedades del área seleccionada",
  show_tutorial: "Mostrar tutorial",
  tutorial_repeat: "Pulsa aquí para volver a empezar el tutorial",
  carbon_quotes_graph_title:
    "Evolución diaria del precio de los cŕeditos de carbono (CC)",
  actual_carbon_quote: "Valor actual CC",
  carbon_quote: "Valor CC",
  download_geojson: "Descargar GeoJSON",
  downloading_geojson: "Descargando GeoJSON",
  geojson_downloaded_successfully: "GeoJSON descargado correctamente",
  geojson_downloading_error: "Error descargando GeoJSON",
  layer_description: "Descripción de la capa",
  updating_asbestos_presence:
    "Actualizando la presencia de amianto en el elemento seleccionado",
  asbestos_presence_updated_successfully:
    "Presencia de amianto actualizada correctamente a",
  asbestos_presence_update_error: "Error al actualizar la presencia de amianto",
  no_element_found: "No se encontró ningún elemento",
  restore_asbestos_presence_title: "Restaurar presencia de amianto",
  restore_asbestos_presence_body:
    "¿Estás seguro de que quieres restaurar la presencia de amianto de este elemento?",
  restoring_asbestos_presence: "Restaurando la presencia de amianto",
  asbestos_presence_restored_successfully:
    "Presencia de amianto restaurada correctamente a",
  change_asbestos_presence: "Cambiar presencia de amianto a...",
  open_settings: "Abrir configuración",
  settings: "Configuración",
  toggle_snap_guides: "Guías de dibujado",
  exit_draw_polygon_mode: "Finalizar dibujo",

  accumulated_carbon_credits: "Créditos de carbono acumulados",
  co2_absoption_evolution: "Evolución de la absorción de CO₂",
  "relation_tCO2/pie_tCO2/km2": "Relación tCO₂/árbol - tCO₂/km²",
  accumulated_credits_by_class: "Créditos acumulados por clase",
  carbon_credits_per_class: "Créditos de carbono por clase",
  class: "Clase",
  select_classes: "Seleccionar clases",
  year: "Año",
  accumulated_absorption_tCO2_km2: "Absorción acumulada (tCO₂/km²)",
  accumulated_absorption_tCO2_ha: "Absorción acumulada (tCO₂/ha)",
  accumulated_absorption_tCO2_tree: "Absorción acumulada (tCO₂/árbol)",
  constant_scenario: "Escenario constante",
  optimistic_scenario: "Escenario optimista",
  pessimistic_scenario: "Escenario pesimista",
  constante_scenario: "Escenario constante",
  optimista_scenario: "Escenario optimista",
  pesimista_scenario: "Escenario pesimista",
  select_scenario: "Seleccionar escenario",

  // Especies Portugal
  "Agricultura com espaços naturais e seminaturais":
    "Agricultura con espacios naturales y seminaturales",
  "Agricultura protegida e viveiros": "Agricultura protegida e invernaderos",
  "Albufeiras de barragens": "Embalses de presas",
  "Áreas em construção": "Áreas en construcción",
  Aterros: "Vertederos",
  Comércio: "Comercio",
  "Culturas temporárias de sequeiro e regadio":
    "Cultivos temporales de secano y regadío",
  "Cursos de água naturais": "Cursos de agua naturales",
  "Equipamentos culturais": "Equipamientos culturales",
  "Equipamentos de lazer": "Equipamientos de ocio",
  "Florestas de castanheiro": "Bosques de castaño",
  "Florestas de espécies invasoras": "Bosques de especies invasoras",
  "Florestas de eucalipto": "Bosques de eucalipto",
  "Florestas de outras folhosas": "Bosques de otras frondosas",
  "Florestas de outras resinosas": "Bosques de otras coníferas",
  "Florestas de outros carvalhos": "Bosques de otros robles",
  "Florestas de pinheiro bravo": "Bosques de pino marítimo",
  "Florestas de sobreiro": "Bosques de alcornoque",
  Indústria: "Industria",
  "Infraestruturas de produção de energia renovável":
    "Infraestructuras de producción de energía renovable",
  "Infraestruturas de tratamento de resíduos e águas residuais":
    "Infraestructuras de tratamiento de residuos y aguas residuales",
  "Infraestruturas para captação, tratamento e abastecimento de águas para consumo":
    "Infraestructuras de captación, tratamiento y abastecimiento de agua para consumo",
  "Instalações agrícolas": "Instalaciones agrícolas",
  "Instalações desportivas": "Instalaciones deportivas",
  "Lixeiras e Sucatas": "Vertederos y chatarrerías",
  Matos: "Matorrales",
  "Mosaicos culturais e parcelares complexos":
    "Mosaicos culturales y parcelarios complejos",
  Olivais: "Olivares",
  "Outros equipamentos e instalações turísticas":
    "Otros equipamientos e instalaciones turísticas",
  "Parques e jardins": "Parques y jardines",
  "Pastagens espontâneas": "Pastos espontáneos",
  "Pastagens melhoradas": "Pastos mejorados",
  Pedreiras: "Canteras",
  Pomares: "Huertos",
  "Rede viária e espaços associados": "Red viaria y espacios asociados",
  "Tecido edificado contínuo predominantemente horizontal":
    "Tejido edificado continuo predominantemente horizontal",
  "Tecido edificado contínuo predominantemente vertical":
    "Tejido edificado continuo predominantemente vertical",
  "Tecido edificado descontínuo": "Tejido edificado discontinuo",
  "Tecido edificado descontínuo esparso":
    "Tejido edificado discontinuo disperso",
  "Vegetação esparsa": "Vegetación dispersa",
  Vinhas: "Viñedos",

  absorption_evolution_per_class: "Evolución de la absorción por clase",
  accumulated_carbon_by_class: "Carbono acumulado por clase",
  carbon_credit_projection_full_area:
    "Proyección de créditos de carbono (área completa)",
  accumulated_credits_per_km2: "Créditos acumulados por km²",
  vegetation_state_distribution: "Distribución del estado de la vegetación",

  // Especies España
  "Abedul pubescens (Betula alba)": "Abedul pubescente (Betula alba)",
  "Acebo (Ilex aquifolium)": "Acebo (Ilex aquifolium)",
  "Agrícola con arbolado": "Agrícola con arbolado",
  "Aliso (Alnus glutinosa)": "Aliso (Alnus glutinosa)",
  Arbolado: "Arbolado",
  "Arce seudoplátano (Acer pseudoplatanus)":
    "Arce falso plátano (Acer pseudoplatanus)",
  "Avellano (Corylus avellana)": "Avellano (Corylus avellana)",
  "Balsas y estanques": "Balsas y estanques",
  "Bardaguera (Salix atrocinerea)": "Sauce cenizo (Salix atrocinerea)",
  "Caminos y sendas": "Caminos y sendas",
  Carreteras: "Carreteras",
  "Castaño (Castanea sativa)": "Castaño (Castanea sativa)",
  "Coberturas de agua": "Coberturas de agua",
  "Construcción deportiva": "Construcción deportiva",
  Coníferas: "Coníferas",
  "Coníferas genéricas": "Coníferas genéricas",
  Cultivos: "Cultivos",
  "Cultivos herbáceos": "Cultivos herbáceos",
  "Cursos de agua": "Cursos de agua",
  Desconocido: "Desconocido",
  Edificación: "Edificación",
  Embalses: "Embalses",
  "Eucalipto globulus (Eucalyptus globulus)":
    "Eucalipto común (Eucalyptus globulus)",
  "Eucalipto nitens (Eucalyptus nitens)":
    "Eucalipto brillante (Eucalyptus nitens)",
  "Fresno excelsior (Fraxinus excelsior)": "Fresno común (Fraxinus excelsior)",
  "Frondosas caducifolias": "Frondosas caducifolias",
  "Frondosas genéricas": "Frondosas genéricas",
  "Frondosas perennifolias": "Frondosas perennifolias",
  "Frutales no cítricos": "Frutales no cítricos",
  "Haya (Fagus sylvatica)": "Haya (Fagus sylvatica)",
  Huerta: "Huerta",
  "Madroño (Arbutus unedo )": "Madroño (Arbutus unedo)",
  Matorral: "Matorral",
  "Otras construcciones": "Otras construcciones",
  Pastizal: "Pastizal",
  "Pastizal-matorral": "Pastizal-matorral",
  "Pasto arbolado": "Pasto arbolado",
  "Peral silvestre (Pyrus spp.": "Peral silvestre (Pyrus spp.)",
  "Pino pináster (Pinus pinaster)": "Pino pinaster (Pinus pinaster)",
  "Pino radiata (Pinus radiata)": "Pino radiata (Pinus radiata)",
  "Pino silvestre (Pinus sylvestris)": "Pino silvestre (Pinus sylvestris)",
  Piscina: "Piscina",
  Prados: "Prados",
  "Rebollo (Quercus pyrenaica)": "Rebollo (Quercus pyrenaica)",
  "Red de transporte terrestre sin catalogar":
    "Red de transporte terrestre sin catalogar",
  "Roble (Quercus petraea)": "Roble albar (Quercus petraea)",
  "Roble pedunculado (Quercus robur)": "Roble pedunculado (Quercus robur)",
  "Serbal de cazadores (Sorbus aucuparia)": "Serbal (Sorbus aucuparia)",
  "Seudotsuga (Pseudotsuga menziesii)": "Pseudotsuga (Pseudotsuga menziesii)",
  "Suelo no edificado": "Suelo no edificado",
  "Terrenos con escasa o nula vegetación":
    "Terrenos con escasa o nula vegetación",
  Viñedo: "Viñedo",
  "Vías urbanas": "Vías urbanas",
  "Zona abierta": "Zona abierta",
  "Zona verde artificial y arbolado urbano":
    "Zona verde artificial y arbolado urbano",
  "Zonas de extracción": "Zonas de extracción",
  "Zonas de vertido": "Zonas de vertido",
  "Zonas pavimentadas o selladas": "Zonas pavimentadas o selladas",
  scenario: "Escenario",
  total_area_ha: "Área total (ha)",
  downloading_all_attached_files: "Descargando todos los archivos adjuntos",
  all_attached_files_downloaded_successfully:
    "Todos los archivos adjuntos se han descargado correctamente",
  download_all_attachments_error: "Error al descargar los archivos adjuntos",
  download_all_attachments: "Descargar todos los archivos adjuntos",
  location_unavailable: "Ubicación no disponible",

  // Solar fields - from asbestos census with solar integration
  SolEnergia: "Energía anual estimada",
  SolCO2: "Toneladas de CO₂ evitadas anualmente",
  SolAhorro: "Ahorro anual estimado",
  SolAreaPnl: "Superficie de paneles fotovoltaicos",
  SolHRA: "Irradiación horizontal anual",
  SolHRM: "Irradiación horizontal media",
  SolTA: "Temperatura anual",
  SolTM: "Temperatura media",
  SolRDNA: "Irradiación directa normal anual",
  SolRDNM: "Irradiación directa normal media",
  SolRAOA: "Irradiación en ángulo óptimo anual",
  SolRAOM: "Irradiación en ángulo óptimo media",
  Potencia_instalada_kWp: "Potencia instalada",
  N_modulos: "Número de módulos a instalar",
  Potencia_modulos: "Potencia de cada módulo",
  Ratio_kWp_m2: "Ratio potencia / superficie",
  "Coste_€_kWp": "Coste por kWp",
  Superficie_cubierta: "Superficie de cubierta",
  Superficie_fv_percent: "Porcentaje de superficie fotovoltaica",
  Lucernario: "Lucernario",
};
export default locale;
